import React from 'react';
import LandingHeader from '../landing/LandingHeader';
import LandingFooter from '../landing/LandingFooter';
import '../../styles/screens/LiveDemo.css';

interface LiveDemoShellProps {
  children: React.ReactNode;
  className?: string;
  /** Wider content for gallery / player (default true). */
  wide?: boolean;
}

/**
 * Shared chrome for public demo pages — same branding as the landing page.
 */
const LiveDemoShell: React.FC<LiveDemoShellProps> = ({ children, className = '', wide = true }) => {
  return (
    <div className={`live-demo-page ${className}`.trim()}>
      <LandingHeader />
      <div className={`live-demo-shell ${wide ? 'live-demo-shell-wide' : 'live-demo-shell-narrow'}`}>
        {children}
      </div>
      <LandingFooter />
    </div>
  );
};

export default LiveDemoShell;
